export default "https://cdn-static.gokick.com/assets/09fae944e838c54f14fd77486c4f90b3472cb396/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";